import { NgRedux } from '@ptl/angular-redux-store';
import { Component } from '@angular/core';
import { FormComponentLookup, FormNavigationConfig, DefaultFormConfig, FormPageComponentClass } from '@ptl/forms';
import { PtlNotificationService, PtlNotificationStyle } from '@ptl/global-components';
import { StateStructure } from '@ptl/state';
import { DateService } from '../../../../shared/services/date.service';
import { ReducerUtilityService } from '../../../../shared/utility-services/reducer-utility.service';
import { SoaFormState, SoaScopeOfSalesData } from '../interfaces/soa.interface';
import { resetSoaState } from '../reducer/soa.reducer';
import { SoaService } from '../services/soa.service';

@FormComponentLookup('page-soa-public-confirmation')
@Component({
    selector: 'app-page-public-confirmation',
    templateUrl: './page-public-confirmation.component.html',
    styleUrls: ['./page-public-confirmation.component.scss'],
    standalone: false
})
export class PagePublicConfirmationComponent extends FormPageComponentClass<FormNavigationConfig> {

  soaId: string;
  isOneCheckboxSelected = true;
  alreadySubmitted = false;
  invalidSoa = false;
  isLoading = false;

  constructor(
    private reducer: ReducerUtilityService,
    private soaService: SoaService,
    private ptlNotificationService: PtlNotificationService,
    private dateUtility: DateService,
    protected ngRedux: NgRedux<StateStructure>) {
    super();
  }

  async ngOnInit() {
    this.initPageConfig();

    this.soaId = this.params.get("ReferralID");
    if (!this.soaId) {
      // can't do anything without one
      return;
    }

    this.soaService.getSoaStatus(this.soaId).then((soaStatus) => {
      // check if this SOA has already been submitted
      if (!(soaStatus?.message?.toLowerCase() === "status updated")) {
        this.alreadySubmitted = true;
      }
    })
    // fallback for service errors
    .catch((err) => this.invalidSoa = true);
  }

  submitHook(formConfig) {
    return new Promise((resolve, reject) => {
      const soaState: SoaFormState = this.reducer.getPayloadState("soa");

      // Validate one checkbox is selected
      if (!soaState.medicareAdvPlans && !soaState.medicarePdpPlans && !soaState.medicareSupplementPlans) {
        this.isOneCheckboxSelected = false;
        reject();
        return;
      }

      this.isOneCheckboxSelected = true;

      // Build the payload
      let payload: SoaScopeOfSalesData = {
        soaTokenId: this.soaId,
        entries: this.formConfig.pages[0].entries,
        formValue: this.pageFormGroups['soa'].value
      };

      // disabled fields are not included in form values so manually adding today's date here
      payload.formValue.todaysDate = this.pageFormGroups['soa'].controls.todaysDate.value;

      this.isLoading = true;

      // Handle the response
      this.soaService.submitPublicSoa(payload).then((response) => {
        if (response?.message === 'Submitted Scope of Appointment to Agent.') {
          this.ptlNotificationService.open({
            title: 'Success',
            content: 'Your appointment has been confirmed',
            primaryButtonText: 'OK',
            notificationStyle: PtlNotificationStyle.SUCCESS
          });

          this.ngRedux.dispatch(resetSoaState());
          this.alreadySubmitted = true;
        }
        else if (response?.message === 'Scope of Appointment already been submitted to Agent.') {
          this.alreadySubmitted = true;
        }
        else {
          this.soaService.showGenericError();
        }

        resolve(true);
      })
      .finally(() => this.isLoading = false);
    });
  }
}
